import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import TestimonialsPage from "@/pages/Testimonials";
import Contact from "@/pages/Contact";
import Drainage from "@/pages/Drainage";
import Groundworks from "@/pages/Groundworks";
import ResidentialLandscaping from "@/pages/ResidentialLandscaping";
import Admin from "@/pages/Admin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/drainage" element={<Drainage />} />
            <Route path="/groundworks" element={<Groundworks />} />
            <Route path="/residential-landscaping" element={<ResidentialLandscaping />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Layout>
        <Toaster theme="dark" position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
